import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import Countries from './components/Countries';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import BlogPreview from './components/BlogPreview';
import Disclaimer from './components/Disclaimer';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function Home() {
  useEffect(() => {
    if (window.location.hash === '#countries') {
      const el = document.getElementById('countries');
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Hero />
        <Countries />
        <HowItWorks />
        <Benefits />
        <BlogPreview />
        <Disclaimer />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}